import LangPicker from "./LangPicker";
export * from "./LangPicker";
export default LangPicker;